import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DevExpressModule } from '../../devexpress.module';
import { SharedModule } from '../../shared/shared.module';
import { ProblemRoutingModule } from './problem-routing.module';
import { ProblemPreviewComponent } from './pages/problem-preview/problem-preview.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';

@NgModule({
  imports: [CommonModule, TranslateModule, ProblemRoutingModule, SharedModule, DevExpressModule],
  declarations: [ProblemPreviewComponent, DashboardComponent],
})
export class ProblemModule {}
